import React, { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import _get from "lodash/get"
import { useTranslation } from "next-i18next"
import CartItems from "@/components/cart/CartItems"
import { showToast } from "@/store/features/genericSlice"
// import CartInfo from "@/components/cart/CartInfo"
import OrderSummary from "@/components/cart/OrderSummary/OrderSummary"
import LookUpCart from "@/components/cart/LookUpCart"
import {
  calculateCartData,
  getCurrency,
  getProductDetails,
} from "@/utils/helper"
import { QuantityModal } from "./QuantityModal/QuantityModal"
import BreakBundle from "./BreakBundle/BreakBundle"
import {
  discount,
  getCart,
  selectCartState,
  shareCart,
  shipmentUpdate,
  taxCalculation,
  addToCart,
  shipmentCart,
  setCart,
  createCart,
  setCardStatus,
} from "@/store/features/cartSlice"
import PageLoader from "@/components/core/PageLoader/PageLoader"
import { getTranslations } from "@/components/cart/localization"
import { getStock } from "@/utils/cart"
import { removeFromCart, changeBundleQty } from "@/utils/removeCart"
import { getLocationUsingIP, getShortenedUrl } from "@/utils/location"
import { selectAuthState } from "@/store/features/authSlice"
import {
  getProfileData,
  getShippingMethods,
  checkInventory,
  getETA,
  clearCartFromStore,
  getPincode,
  breakBundleItem,
  calculateInventoryStatus,
  getPromoCodeList,
  scrollToError,
} from "@/components/cart/cartHelper"
import { getConfig } from "@/constants/config"
import {
  analyticsCB,
  calculateCartAnalytics,
} from "@/components/cart/cartAnalytics"
import CustomerInformation from "../Shared/CustomerInformation"
import ArrowLeft from "@/public/icons/back-arrow.svg"
import Link from "next/link"
import { getCustomerCartId } from "@/utils/cart"
import { isBundleWithInstallation } from "@/components/cart/utils"
import LandingFiller from "@/components/cart/LandingFiller"
import StickyButton from "../checkout/StickyButton"
import { store } from "@/store/index"
import CartInfo from "@/components/cart/CartInfo"
import CartUpdatedModal from "../checkout/CartUpdatedModal"

const CartLanding = props => {
  const { contactnumber } = props.data
  const { t } = useTranslation("cart")

  const {
    cart: activeCart = {},
    status,
    promoError,
    noShippingItemsInCheckout,
    shippingItemstoCheckout,
    isCartLoading = false,
    isCheckoutMergeModal = false,
  } = useSelector(selectCartState)

  const { isAuth, user: { firstName = "", sub = "", persona = [] } = {} } =
    useSelector(selectAuthState)

  const isIscUser = persona?.includes("IN_Kohler_ISC")

  const staticText = getTranslations(t)
  const [zipcode, setZipcode] = useState("")
  const [redirect, setRedirect] = useState(false)
  const [abandonedFlag, showAbandonedCarts] = useState(false)
  const qtyLoading = false
  const [showAlert, setShowAlert] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [showBundleModal, setShowBundleModal] = useState(false)
  const [stickyCheckout, setStickyCheckout] = useState(true)
  const [checkoutSeen, setCheckoutSeen] = useState(false)
  const [isAbandonedCart, setAbandonedCart] = useState(
    isIscUser && getCustomerCartId() ? true : false
  )
  const [modalText, setModalText] = useState("")
  const [errors, setErrors] = useState({})
  const [inventoryData, setInventoryData] = useState({
    nonDeliverableData: [],
    outOfStockData: [],
    installationServiceData: [],
  })
  const [cartData, setCartData] = useState({})
  const [cartLoad, setCartLoad] = useState(true)
  const [cartQtyLoad, setCartQtyLoad] = useState(true)
  const [isFirstVisit, setIsFirstVisit] = useState(true)
  const [promoCodesList, setPromoCodesList] = useState([])
  const [applicablePromos, setApplicablePromos] = useState([])
  const [promo, setPromo] = useState("")
  const [loadingText, setLoadingText] = useState(null)
  const checkoutUrl = useRef("")
  const currencySign = useRef("")
  const dispatch = useDispatch()
  const pageRenderRef = useRef({ isFirstRenderDone: false })

  const childRef = useRef()

  const { key: cartKey = "" } = activeCart
  const inventoryCheck = async (pin = "") => {
    try {
      const pinCodeForInventory = pin ? pin : zipcode
      const { inventoryData: errorData, newLineItems } = await checkInventory(
        false,
        pinCodeForInventory,
        true
      )
      if (Object?.keys(errorData)?.length) {
        const { nonDeliverableData, outOfStockData, installationServiceData } =
          calculateInventoryStatus(newLineItems)
        setInventoryData({
          nonDeliverableData,
          outOfStockData,
          installationServiceData,
        })
        setShowAlert(true)
      } else {
        setInventoryData({
          nonDeliverableData: [],
          outOfStockData: [],
          installationServiceData: [],
        })
        setShowAlert(false)
      }
      setErrors(errorData)
      dispatch(setCardStatus(false))
      setTimeout(() => {
        const itemId = store?.getState()?.cart?.itemId
        if (itemId && itemId !== "") scrollToError(false, itemId)
      }, 500)
      return errorData
    } catch (e) {
      setShowAlert(false)
      dispatch(setCardStatus(false))
      return true
    }
  }

  const loadAbandonedCart = cartState => {
    setAbandonedCart(cartState)
  }

  const initialCartLoad = () => {
    try {
      dispatch(setCardStatus(true))
      dispatch(getCart())
        .unwrap()
        .then(async (rsp = {}) => {
          const { cartExists = "", error = "" } = rsp
          if (cartExists === "false" && error === "No active cart exists.") {
            dispatch(createCart({ currency: "INR" }))
              .unwrap()
              .catch(ex => console.log(ex))
              .finally(() => {
                dispatch(setCardStatus(false))
              })
          } else if (rsp?.lineItems?.length) {
            dispatch(setCardStatus(false))

            const payload = {
              actions: [
                {
                  action: "recalculate",
                  updateProductData: true,
                },
                {
                  action: "calculateTax",
                },
                {
                  action: "syncCartPrices",
                },
              ],
            }
            const calcTax = () => {
              dispatch(addToCart(payload))
                .unwrap()
                .then(async rsp => {
                  const zipCode = await getZipCode(rsp)
                  await inventoryCheck(zipCode)
                })
                .catch(e => {
                  console.log(e)
                  dispatch(setCardStatus(false))
                })
            }

            if (document.prerendering) {
              document.addEventListener("prerenderingchange", calcTax, {
                once: true,
              })
            } else {
              calcTax()
            }
          } else {
            dispatch(setCardStatus(false))
          }
        })
        .catch(e => {
          console.log(e)
          dispatch(setCardStatus(false))
        })
    } catch (e) {
      console.log(e)
      dispatch(setCardStatus(false))
    }
  }

  const getPromoCodes = async (quantityChange = false) => {
    const applicablePromos = await getPromoCodeList(cartData.cart?.cartID)
    setApplicablePromos(applicablePromos)
    updatePromoList(applicablePromos)

    if (quantityChange) {
      if (activeCart?.promoCode?.length) {
        setPromo(activeCart?.promoCode?.[0].code)
      } else {
        setPromo("")
      }
    }
  }

  const updatePromoList = applicableCodes => {
    const codes = applicableCodes ? applicableCodes : applicablePromos
    const activePromo = cartData?.promoCodes?.length
      ? cartData?.promoCodes?.[0]
      : ""
    let promoList = codes.map(item => {
      if (item.code === activePromo.code) {
        item.isApplied = true
        item.id = activePromo.id
        item.discount = activePromo.discount
      } else {
        item.isApplied = false
      }

      return item
    })
    if (activePromo !== "") {
      const index = codes.findIndex(item => item.code === activePromo.code)
      if (index === -1) {
        promoList = [
          {
            isApplied: true,
            id: activePromo.id,
            discount: activePromo.discount,
            code: activePromo.code,
            description: activePromo.description,
          },
          ...promoList,
        ]
        promoList = promoList.length > 3 ? promoList.slice(0, 3) : promoList
      }
    }
    setPromoCodesList(promoList)
  }

  useEffect(() => {
    initialCartLoad()
    getConfig().then(async config => {
      currencySign.current = _get(
        config,
        "internationalization.currencySign",
        ""
      )
      checkoutUrl.current = await getShortenedUrl(
        _get(config, "general.checkoutPagePath", "")
      )
    })
  }, [])

  useEffect(() => {
    if (cartData.cart?.cartID) getPromoCodes()
  }, [cartData.cart?.cartID])

  useEffect(() => {
    updatePromoList()
  }, [cartData.promoCodes])

  useEffect(() => {
    if (activeCart?.id && redirect === false) {
      dispatch(setCardStatus(true))
      calculateCartData(
        {
          cart: activeCart,
          shippingItemstoCheckout: shippingItemstoCheckout,
          noShippingItems: noShippingItemsInCheckout,
          quantityUpdatedFlag: window?.pageObj?.updatedSku
            ? window?.pageObj?.updatedSku
            : false,
        },
        true
      ).then(async rsp => {
        if (rsp?.promoCodes?.length) {
          setPromo(rsp?.promoCodes?.[0].code)
        } else {
          setPromo("")
        }
        if (window?.pageObj?.updatedSku) {
          delete window.pageObj.updatedSku
        }
        if (window.pageObj) {
          window.pageObj.cart = rsp.cart
        }

        analyticsCB("success", rsp.cart)
        let windowDataLayer = window.adobeDataLayer
        if (
          windowDataLayer &&
          windowDataLayer.length > 0 &&
          windowDataLayer[0].page
        ) {
          calculateCartAnalytics({ cart: rsp.cart })
          windowDataLayer = window.adobeDataLayer
          if (
            windowDataLayer.length > 1 &&
            windowDataLayer[windowDataLayer.length] &&
            windowDataLayer[windowDataLayer.length].event &&
            (windowDataLayer[windowDataLayer.length].event === "cmp:show" ||
              windowDataLayer[windowDataLayer.length].event === "cmp:click") &&
            windowDataLayer[windowDataLayer.length].page &&
            !windowDataLayer[windowDataLayer.length].page.cart
          ) {
            windowDataLayer[windowDataLayer.length].page.cart = rsp.cart
          }
        }
        setCartData(prevState => {
          if (!prevState) {
            return rsp
          }
          const newData = { ...rsp }
          newData.cartItems?.forEach(item => {
            if (
              !item.isBundleChildItem &&
              item.category !== "Install Services"
            ) {
              const d = prevState.cartItems?.find(i => i.id === item.id)
              if (d && d.isSelected) {
                item.isSelected = d.isSelected
              }
            }
          })
          return newData
        })
        setCartLoad(false)
        setCartQtyLoad(false)
        dispatch(setCardStatus(false))
      })
    } else if (
      Object.keys(activeCart).length === 0 ||
      activeCart?.lineItems?.length === 0
    ) {
      setCartData({})
      setCartLoad(false)
      setCartQtyLoad(false)
      dispatch(setCardStatus(false))
    }
    return () => setShowAlert(false)
  }, [activeCart, shippingItemstoCheckout, noShippingItemsInCheckout])

  useEffect(() => {
    if (
      pageRenderRef?.current["isFirstRenderDone"] &&
      activeCart?.id &&
      activeCart?.lineItems?.length
    ) {
      inventoryCheck()
    }
    if (pageRenderRef?.current) {
      pageRenderRef.current["isFirstRenderDone"] = true
    }
    return () => setShowAlert(false)
  }, [activeCart?.lineItems?.length])

  const handleAddtoCartResponse = ({ payload }) => {
    if (payload) {
      dispatch(setCart(payload))
      if (payload?.lineItems?.length === 0) {
        setShowAlert(false)
      }
    }
  }

  const handleQuantityChange = async (
    sku,
    quantity,
    isBundle,
    masterVariantKey,
    stockCheck,
    cb,
    productData = {},
    id = ""
  ) => {
    const {
      isInstallService,
      installServiceName,
      installServiceQty,
      totalInstallServiceQty,
      isInstallItem,
      cartQuantity,
      lineItemId,
      curWarehouses = [],
      section,
    } = getProductDetails(activeCart, sku, isBundle, productData)
    let payload
    let isBundleWithInstall = false

    if (quantity < cartQuantity) {
      setLoadingText("Loading...")
    }

    try {
      dispatch(setCardStatus(true))
      setCartQtyLoad(true)
      let pincode = await getPincode()
      if (!pincode) {
        pincode = activeCart?.billingAddress?.postalCode
      }
      if (isBundle) {
        isBundleWithInstall = isBundleWithInstallation(
          sku,
          activeCart.lineItems
        )
      }
      if (isInstallItem) {
        const isBundleInstallService = productData.isBundleParent
        const {
          installServiceName,
          installServiceQty,
          lineItemId: productLineItemId,
        } = getProductDetails(activeCart, productData?.sku)

        let warehouses = []

        if (!isBundleInstallService) {
          warehouses = await getETA(
            productData.sku,
            productData.masterVariantKey,
            productData.quantity,
            pincode
          )
        }
        let payload1
        // installation service decrease
        if (installServiceQty > quantity) {
          payload1 = removeFromCart({
            id: lineItemId,
            quantity: installServiceQty - quantity,
            isComboSku: isBundle,
          })
        }
        // installation service increase
        else {
          payload1 = [
            {
              action: isBundleInstallService
                ? "changeBundleSKUQuantity"
                : "changeLineItemQuantity",
              lineItemId: isBundleInstallService ? id : lineItemId,
              quantity: quantity,
            },
          ]
        }
        let payload2 = []
        if (!isBundleInstallService) {
          payload2 = [
            {
              action: "setLineItemCustomType",
              lineItemId: productLineItemId,
              type: {
                key: "cartLineItemAdditionalInfo",
                typeId: "type",
              },
              fields: {
                associatedService: installServiceName,
                associatedServiceQty: quantity,
                warehouses,
                section,
              },
            },
          ]
        }
        payload = [...payload1, ...payload2]
      } else {
        let warehouses = curWarehouses

        if (quantity > cartQuantity) {
          warehouses = await getETA(
            sku,
            masterVariantKey,
            quantity,
            pincode,
            false,
            isBundle,
            () => cb(staticText.noItemsToShip)
          )
        }

        if (isBundle && !warehouses) {
          dispatch(setCardStatus(false))
          setCartQtyLoad(false)
          return
        }

        // product quantity decrease
        if (cartQuantity > quantity) {
          const qty = cartQuantity - quantity
          payload = isBundle
            ? changeBundleQty(
                lineItemId,
                sku,
                quantity,
                warehouses,
                isBundleWithInstall
              )
            : removeFromCart({
                id: lineItemId,
                quantity: qty,
                isComboSku: isBundle,
              })
          if (isInstallService) {
            const currentInstallationQty = totalInstallServiceQty - qty
            const productInstallationQty = installServiceQty - qty
            let installationLineItemId = null

            if (isBundle) {
              installationLineItemId = productData.bundleItems?.find(
                item => item.category === "Install Services"
              )?.id
            } else {
              const { lineItemId } = getProductDetails(
                activeCart,
                installServiceName,
                false,
                productData
              )
              installationLineItemId = lineItemId
            }

            const payload2 = [
              {
                action: isBundle
                  ? "changeBundleSKUQuantity"
                  : "changeLineItemQuantity",
                lineItemId: installationLineItemId,
                quantity:
                  productInstallationQty > 0
                    ? currentInstallationQty
                    : totalInstallServiceQty - (installServiceQty - 1),
              },
            ]
            if (!isBundle) {
              payload2.push({
                action: "setLineItemCustomType",
                lineItemId: lineItemId,
                type: {
                  key: "cartLineItemAdditionalInfo",
                  typeId: "type",
                },
                fields: {
                  associatedService: installServiceName,
                  associatedServiceQty:
                    productInstallationQty > 0 ? productInstallationQty : 1,
                  warehouses,
                  section,
                },
              })
            }
            payload = [...payload, ...payload2]
            setModalText("decreased")
          } else {
            if (!isBundle) {
              const payload2 = [
                {
                  action: "setLineItemCustomType",
                  lineItemId,
                  type: {
                    key: "cartLineItemAdditionalInfo",
                    typeId: "type",
                  },
                  fields: {
                    warehouses,
                    section,
                  },
                },
              ]
              payload = [...payload, ...payload2]
            }
          }
        } else {
          let currentQty
          const stock = await getStock(sku)
          if (stock === cartQuantity) {
            const msg = staticText.noItemsToShip
            cb(msg)
            dispatch(setCardStatus(false))
            setCartQtyLoad(false)
            setCartLoad(false)
            setCartQtyLoad(false)
            dispatch(getCart())
            return
          } else if (stock <= 0) {
            const msg = staticText.outOfStock
            dispatch(setCardStatus(false))
            setCartLoad(false)
            setCartQtyLoad(false)
            cb(msg)
            return
          } else if (quantity > stock) {
            currentQty = stock - cartQuantity
            payload = isBundle
              ? changeBundleQty(
                  lineItemId,
                  sku,
                  currentQty + cartQuantity,
                  warehouses,
                  isBundleWithInstall
                )
              : [
                  {
                    action: "changeLineItemQuantity",
                    lineItemId,
                    quantity: currentQty + cartQuantity,
                  },
                ]
            const msg = t("kf.cart.label.availableToShip", {
              qty: stock,
            })
            cb(msg)
          } else {
            currentQty = quantity - cartQuantity
            payload = isBundle
              ? changeBundleQty(
                  lineItemId,
                  sku,
                  quantity,
                  warehouses,
                  isBundleWithInstall
                )
              : [
                  {
                    action: "changeLineItemQuantity",
                    lineItemId,
                    quantity,
                  },
                ]
          }
          if (isInstallService) {
            let installationLineItemId = null

            if (isBundle) {
              installationLineItemId = productData.bundleItems?.find(
                item => item.category === "Install Services"
              )?.id
            } else {
              const { lineItemId } = getProductDetails(
                activeCart,
                installServiceName,
                false,
                productData
              )
              installationLineItemId = lineItemId
            }
            const payload2 = [
              {
                action: isBundle
                  ? "changeBundleSKUQuantity"
                  : "changeLineItemQuantity",
                lineItemId: installationLineItemId,
                quantity: totalInstallServiceQty + currentQty,
              },
            ]

            if (!isBundle) {
              payload2.push({
                action: "setLineItemCustomType",
                lineItemId,
                type: {
                  key: "cartLineItemAdditionalInfo",
                  typeId: "type",
                },
                fields: {
                  associatedService: installServiceName,
                  associatedServiceQty: installServiceQty + currentQty,
                  warehouses,
                  section,
                },
              })
            }
            payload = [...payload, ...payload2]
            setModalText("increased")
          } else {
            if (!isBundle) {
              const payload2 = [
                {
                  action: "setLineItemCustomType",
                  lineItemId,
                  type: {
                    key: "cartLineItemAdditionalInfo",
                    typeId: "type",
                  },
                  fields: {
                    warehouses,
                    section,
                  },
                },
              ]
              payload = [...payload, ...payload2]
            }
          }
        }
      }
      payload.push({
        action: "calculateTax",
      })
      const body = {
        actions: payload,
      }
      dispatch(addToCart(body))
        .unwrap()
        .then(res => {
          handleAddtoCartResponse(res)
          // getShippingMethods()
          // dispatchCallbackHandler("taxCalculation")
          dispatch(setCardStatus(false))
          setCartLoad(false)
          setCartQtyLoad(false)
          isInstallService && isFirstVisit && setShowModal(true)
          if (isInstallService) setIsFirstVisit(false)
          getPromoCodes(true)
          setLoadingText(null)
        })
        .catch(e => {
          dispatch(setCardStatus(false))
          setCartLoad(false)
          setCartQtyLoad(false)
          setLoadingText(null)
        })
    } catch (e) {
      dispatch(setCardStatus(false))
      setCartQtyLoad(false)
      setCartLoad(false)
      setLoadingText(null)
      console.log(e)
    }
  }

  const dispatchCallbackHandler = (type, payload = null) => {
    switch (type) {
      case "discount": {
        return dispatch(discount(payload))
      }
      case "taxCalculation": {
        return dispatch(taxCalculation())
      }
      case "shipmentUpdate": {
        return dispatch(shipmentUpdate(payload))
      }
      case "shareCart": {
        return dispatch(shareCart(payload))
      }
      case "addToCart": {
        return dispatch(addToCart(payload))
      }
      case "shipmentcart": {
        return dispatch(shipmentCart())
      }
    }
  }

  const getZipCode = async payload => {
    // const { postalCode, state, country } = activeCart?.shippingAddress ?? {}
    try {
      const { postalCode, state, country } = payload?.shippingAddress ?? {}

      if (postalCode && state && country) {
        const shippingZip = localStorage.getItem("shippingZip")
        if (!shippingZip) {
          localStorage.setItem("shippingZip", postalCode)
        }
        setZipcode(postalCode)
        await getShippingMethods()
        return postalCode
      }
      const getCookieValue = name =>
        document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")?.pop() ||
        ""
      let zip = getCookieValue("pincode")
      if (!zip && isAuth && !isIscUser) {
        const profile = await getProfileData(staticText.profileFailure)
        if (profile?.addresses) {
          const defAddr = profile.defaultShippingAddressId
            ? profile.addresses.find(
                item => item.id === profile.defaultShippingAddressId
              )
            : profile.addresses[0]
          zip = defAddr?.postalCode
        }
      }
      setZipcode(zip)
      return zip
    } catch (e) {
      console.error(e)
    }
  }

  const showToastHandler = msg =>
    dispatch(
      showToast({
        message: msg,
        isVisible: true,
      })
    )

  const returnToCart = () => {
    clearCartFromStore(sub)
    showAbandonedCarts(!abandonedFlag)
  }

  const handleBundleBreak = async () => {
    await breakBundleItem(showBundleModal)
  }

  const recoveredStatus = activeCart?.custom?.fields?.recoveredStatus
  const handleStickyCheckout = () => {
    if (childRef.current) {
      childRef.current.handleCheckout()
    }
  }
  const CHECKOUT_BUTTON_LABEL = isAbandonedCart
    ? staticText.checkoutAsCustomer
    : staticText.checkout

  const handleSelection = (id, isSelected) => {
    setCartData(cart => {
      const newData = { ...cart }
      newData.cartItems?.forEach(item => {
        if (!item.isBundleChildItem && item.category !== "Install Services") {
          if (!id || item.id === id) {
            item.isSelected = isSelected
          }
        }
      })
      return newData
    })
  }

  if (cartLoad) {
    return <LandingFiller />
  }

  return (
    <>
      <PageLoader loading={cartQtyLoad} cartLoading={true} text={loadingText} />
      <div className="root container responsivegrid" id="main-content">
        <StickyButton
          stickyCheckout={stickyCheckout}
          handleCheckout={handleStickyCheckout}
          checkoutSeen={checkoutSeen}
          setCheckoutSeen={setCheckoutSeen}
          checkoutLabel={CHECKOUT_BUTTON_LABEL}
          checkoutFlag={true}
          i18n={staticText}
          disableCheckout={cartData?.cartItems?.length === 0 || showAlert}
        />
        <div id="container-181c79087e" className="cmp-container">
          <div className="container responsivegrid">
            <div id="container-9241f43c45" className="cmp-container">
              {isIscUser ? (
                <LookUpCart loadAbandonedCart={loadAbandonedCart} />
              ) : null}
              <div className="cart-landing">
                <div className="container kf-react-container cart-landing">
                  {!abandonedFlag &&
                  isAbandonedCart &&
                  cartData?.cartItems?.length > 0 ? (
                    <div className="back-to-cart">
                      <img
                        src={ArrowLeft?.src}
                        alt="Back"
                        className="pr-10 pb-5"
                        height="20"
                        width="40"
                      />
                      <button
                        className="back-to-cart-text"
                        onClick={returnToCart}
                      >
                        Back to Cart
                      </button>
                    </div>
                  ) : null}
                  <div className="row no-gutters row-space-between">
                    <div
                      className={`${
                        cartData?.cartItems?.length > 0
                          ? "col-lg-9 cart-item-list-section"
                          : "col-lg-12"
                      } ml-full-width `}
                    >
                      {true && (
                        <CartItems
                          page="cart"
                          loading={isCartLoading}
                          i18n={staticText}
                          qtyLoading={qtyLoading}
                          cartItems={cartData?.cartItems}
                          onQuantityChange={handleQuantityChange}
                          dispatchCallback={dispatchCallbackHandler}
                          estimatedTotal={cartData?.estimatedTotal}
                          cartId={activeCart?.id}
                          cartKey={cartKey}
                          isIscUser={isIscUser}
                          checkoutUrl={`${checkoutUrl.current}?pin=${zipcode}`}
                          currencySign={currencySign.current}
                          disableCheckout={
                            cartData?.cartItems?.length === 0 || showAlert
                          }
                          showAlert={showAlert}
                          specFiles={cartData?.specFiles}
                          isAuth={isAuth}
                          username={firstName}
                          isCartPage
                          errors={errors}
                          abandonedFlag={abandonedFlag}
                          isAbandonedCart={isAbandonedCart}
                          showToast={showToastHandler}
                          loadAbandonedCart={loadAbandonedCart}
                          handleAbandonedCarts={showAbandonedCarts}
                          showBundleModal={setShowBundleModal}
                          inventoryData={inventoryData}
                          setCartQtyLoad={setCartQtyLoad}
                          handleSelection={handleSelection}
                          setLoadingText={setLoadingText}
                        />
                      )}
                    </div>
                    {cartData?.cartItems?.length > 0 ? (
                      <div className="ml-full-width order-summary-cart">
                        {isAbandonedCart ? (
                          <div className="row no-gutters pb-30">
                            <CustomerInformation
                              email={activeCart.customerEmail}
                              address={activeCart.billingAddress}
                              staticText={staticText}
                            />
                          </div>
                        ) : null}
                        <OrderSummary
                          i18n={staticText}
                          promoError={promoError}
                          status={status}
                          toastError={showToastHandler}
                          zipcode={zipcode}
                          dispatchCallback={dispatchCallbackHandler}
                          cartId={activeCart?.id}
                          estimatedTotal={cartData?.estimatedTotal}
                          cartKey={cartKey}
                          isIscUser={isIscUser}
                          checkoutUrl={checkoutUrl.current}
                          currencySign={currencySign.current}
                          showAlert={showAlert}
                          specFiles={cartData?.specFiles}
                          isAuth={isAuth}
                          username={firstName}
                          isCartPage
                          errors={errors}
                          recoveredStatus={recoveredStatus}
                          abandonedFlag={abandonedFlag}
                          handleAbandonedCarts={showAbandonedCarts}
                          disableCheckout={
                            cartData?.cartItems?.length === 0 || showAlert
                          }
                          loadAbandonedCart={loadAbandonedCart}
                          inventoryCheck={inventoryCheck}
                          isAbandonedCart={isAbandonedCart}
                          redirectCallback={setRedirect}
                          stickyCheckout={stickyCheckout}
                          setStickyCheckout={setStickyCheckout}
                          checkoutSeen={checkoutSeen}
                          setCheckoutSeen={setCheckoutSeen}
                          ref={childRef}
                          promoCodesList={promoCodesList}
                          promo={promo}
                          setPromo={setPromo}
                          updatePromoList={updatePromoList}
                          {...cartData}
                        />
                      </div>
                    ) : null}
                    {/* {cartData?.cartItems?.length > 0 ? ( */}
                    <CartInfo i18n={staticText} supportLine={contactnumber} />
                    {/* ) : null} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div></div>
        <QuantityModal
          showModal={showModal}
          setShowModal={setShowModal}
          modalText={modalText}
        />
        <BreakBundle
          showModal={showBundleModal}
          setShowModal={setShowBundleModal}
          onConfirm={handleBundleBreak}
        />
      </div>
      {isCheckoutMergeModal ? (
        <CartUpdatedModal
          isCheckoutModal={isCheckoutMergeModal}
          staticTexts={staticText}
          isCartLandingPage={true}
        />
      ) : null}
    </>
  )
}

export default CartLanding
